export default "__VITE_ASSET__DY7ym_YH__"